import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=4385df00&scoped=true"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=4385df00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385df00",
  null
  
)

export default component.exports